import React from "react";
import { LoadingSpinner } from "./icon-components/Spinner";

export default function Loading() {
  return (
    <div className="flex justify-center fixed z-20 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10">
      <LoadingSpinner />
    </div>
  );
}
